import { Component } from '@angular/core'
// Styles loaded via src/styles/styles.less -> components/error-page.less

@Component({
    selector: 'ca-error-401',
    templateUrl: './error-401.component.html',
    standalone: false
})
export class Error401Component {

    goBack(): void {
        window.history.go(-2)
    }

}